import { getAreaLogic } from "../helper/area-logic";
import { ObjectType } from "./useObjectType";

export const useAreaLogic = (
  objectType: ObjectType | null,
  level: number,
  rootAreaType: string | undefined
) => getAreaLogic(objectType, level, rootAreaType);
